export default "__VITE_ASSET__DmOTmjGm__"